import { HStack } from "@chakra-ui/react"
import ReactSelectInput from "@pathwright/ui/src/components/form/form-select/ReactSelectInput"
import ReactSelectInputOption from "@pathwright/ui/src/components/form/form-select/ReactSelectInputOption"
import ReactSelectInputOptionLabel from "@pathwright/ui/src/components/form/form-select/ReactSelectInputOptionLabel"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import PropTypes from "prop-types"
import { ROLE_TYPE_HELP_ARTICLES } from "./constants"
import { getRoleOptions } from "./utils"

const LearnMore = ({ roleType, options }) => {
  const { t } = useTranslate()
  const { url, label } = ROLE_TYPE_HELP_ARTICLES[roleType] || {}

  return url ? (
    <div style={{ padding: "10px" }}>
      <Text.Body>
        <a href={url} target="_blank">
          <HStack whiteSpace="pre">
            <Pathicon icon="external-link" />
            {label ? (
              <span>{t(label)}</span>
            ) : (
              <span>
                Learn more about{" "}
                {options.length == 1 ? "this role" : "these roles"}
              </span>
            )}
          </HStack>
        </a>
      </Text.Body>
    </div>
  ) : null
}

const Option = (props) => {
  const {
    value,
    icon,
    label,
    // label_plural,
    descriptor,
    roleType
  } = props.data

  if (value === null) {
    // HACK: inserting learn more link as last "option"
    return <LearnMore roleType={roleType} options={props.options} />
  }

  return (
    <ReactSelectInputOption
      {...props}
      icon={icon}
      label={label}
      descriptor={descriptor}
    />
  )
}

const OptionLabel = ({ option, prompt }) => <div>{prompt(option)}</div>

const selectRoleDefaultPropPrompt = ({ icon, label }) => (
  <ReactSelectInputOptionLabel icon={icon} label={label} />
)

const SelectRole = ({
  prompt = selectRoleDefaultPropPrompt,
  roleType,
  roleFilter,
  ...passProps
}) => {
  const translateProps = useTranslate()
  const options = [
    ...getRoleOptions(roleType, roleFilter, translateProps),
    {
      value: null,
      roleType
    }
  ]

  return (
    <ReactSelectInput
      {...passProps}
      className="SelectRole"
      value={options.find((option) => option.value === passProps.value) ?? null}
      options={options}
      components={{
        Option
      }}
      formatOptionLabel={(props) => (
        <OptionLabel option={props} prompt={prompt} />
      )}
      isSearchable={false}
      styles={{
        menu: (base) => ({
          ...base,
          maxHeight: 500
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: 500
        })
      }}
    />
  )
}

SelectRole.propTypes = {
  prompt: PropTypes.func.isRequired
}

export default SelectRole
